const description = `The cycle diagram is a circular layout of nodes, where each 
node is connected to the next in a loop. It is useful for representing processes 
or systems that are cyclical in nature, such as feedback loops or iterative processes. 
`;

export default description;
